"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preserveAlpha = exports.addColorChangeContext = exports.ColorCollectionDriver = void 0;
var tslib_1 = require("tslib");
var chroma_js_1 = tslib_1.__importDefault(require("chroma-js"));
var css_box_shadow_1 = require("css-box-shadow");
var core_1 = require("@stylable/core");
var stylable_collection_1 = require("./stylable-collection");
var stylable_shorthands_1 = require("../stylable-shorthands");
var stylable_gradient_1 = require("../stylable-gradient");
var colors_1 = require("../utils/css-utils/colors");
function replaceColor(sourceValue, currValue, newValue) {
    var currValueHex = chroma_js_1.default(currValue).hex();
    return sourceValue
        .replace(currValue, newValue)
        .replace(currValueHex, newValue)
        .replace(currValueHex.toUpperCase(), newValue)
        .replace(currValueHex.toLowerCase(), newValue);
}
var ColorCollectionDriver = /** @class */ (function (_super) {
    tslib_1.__extends(ColorCollectionDriver, _super);
    function ColorCollectionDriver() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorCollectionDriver.prototype.router = function (decl, sheet, declarations) {
        var addColor = addColorChangeContext.bind(this, declarations, decl);
        if (decl.prop === 'background' || decl.prop === 'background-image') {
            this.handleBackgroundProperty(sheet, decl.value, addColor);
        }
        else if (decl.prop === 'border-image' || decl.prop === 'border-image-source') {
            this.handleBorderImageProperty(sheet, decl.value, addColor);
        }
        else if (decl.prop === core_1.valueMapping.mixin) {
            this.handleMixinProperty(sheet, decl, addColor);
        }
        else if (~colors_1.colorProperties.indexOf(decl.prop)) {
            this.handleDirectColorProperty(sheet, decl.value, addColor);
        }
        else if (~colors_1.shorthandsContainingColor.indexOf(decl.prop)) {
            this.handleNonBackgroundShorthandProperty(sheet, decl, addColor);
        }
        else if (~colors_1.nonExpandablesContainingColor.indexOf(decl.prop)) {
            this.handleNonExpandableProperty(sheet, decl.value, addColor);
        }
    };
    ColorCollectionDriver.prototype.handleDirectColorProperty = function (sheet, declValue, adder) {
        var updateFromAST = this.updateFromAST.bind(this);
        function changeDirectColor(value) {
            this.declaration.value = preserveAlpha(sheet, value, this.declaration.value);
            updateFromAST(this.declaration);
        }
        adder(sheet.evalDeclarationValue(declValue), changeDirectColor);
    };
    ColorCollectionDriver.prototype.handleNonBackgroundShorthandProperty = function (sheet, decl, adder) {
        var updateFromAST = this.updateFromAST.bind(this);
        var shorthands = new stylable_shorthands_1.StylableShorthands(sheet.evalDeclarationValue.bind(sheet));
        var expandedDeclaration = shorthands.shallowExpandDeclaration(decl);
        colors_1.shorthandToColorPropMap[decl.prop].forEach(function (colorProp) {
            function changeNonBackgroundShorthand(val) {
                var currValue = shorthands.shallowExpandDeclaration(this.declaration)[colorProp];
                var newValue = preserveAlpha(sheet, val, currValue);
                this.declaration.value = replaceColor(sheet.evalDeclarationValue(this.declaration.value), currValue, newValue);
                updateFromAST(this.declaration);
            }
            var value = expandedDeclaration[colorProp];
            value && adder(value, changeNonBackgroundShorthand);
        });
    };
    ColorCollectionDriver.prototype.handleBackgroundProperty = function (sheet, declValue, adder) {
        var updateFromAST = this.updateFromAST.bind(this);
        var backgrounds = stylable_shorthands_1.splitLayers(sheet.evalDeclarationValue(declValue));
        backgrounds.forEach(function (layer, index) {
            var expandedLayer = stylable_gradient_1.expandGradient(layer, 'background-image', 'background');
            var backgroundImageValue = expandedLayer['background-image'];
            if (backgroundImageValue && typeof backgroundImageValue !== 'string' && backgroundImageValue.colorStops) {
                backgroundImageValue.colorStops.forEach(function (colorStop, colorIndex) {
                    function changeBackgroundGradientColor(value) {
                        var currBackgrounds = stylable_shorthands_1.splitLayers(this.declaration.value);
                        var currEval = sheet.evalDeclarationValue(currBackgrounds[index]);
                        var currLayer = stylable_gradient_1.expandGradient(currEval, 'background-image', 'background')['background-image'];
                        var currValue = stylable_gradient_1.normalizeGradientColorStop(currLayer.colorStops[colorIndex]);
                        var currValueMatcher = RegExp(currValue.replace('(', '\\(\\s*').replace(')', '\\s*\\)').replace(/\s/g, '\\s*'));
                        currBackgrounds[index] = currEval.replace(currValueMatcher, preserveAlpha(sheet, value, currValue));
                        this.declaration.value = currBackgrounds.join(', ');
                        updateFromAST(this.declaration);
                    }
                    adder(stylable_gradient_1.normalizeGradientColorStop(colorStop), changeBackgroundGradientColor);
                });
            }
            function changeBackgroundColor(value) {
                var currBackgrounds = stylable_shorthands_1.splitLayers(sheet.evalDeclarationValue(this.declaration.value));
                var currValue = stylable_gradient_1.expandGradient(currBackgrounds[index], 'background-image', 'background')['background-color'];
                var newValue = preserveAlpha(sheet, value, currValue);
                currBackgrounds[index] = replaceColor(currBackgrounds[index], currValue, newValue);
                this.declaration.value = currBackgrounds.join(', ');
                updateFromAST(this.declaration);
            }
            var backgroundColorValue = expandedLayer['background-color'];
            backgroundColorValue && adder(backgroundColorValue, changeBackgroundColor);
        });
    };
    ColorCollectionDriver.prototype.handleBorderImageProperty = function (sheet, declValue, adder) {
        var updateFromAST = this.updateFromAST.bind(this);
        var expandedGradient = stylable_gradient_1.expandGradient(sheet.evalDeclarationValue(declValue), 'border-image-source', 'border-image');
        var borderImageSourceValue = expandedGradient['border-image-source'];
        if (borderImageSourceValue && typeof borderImageSourceValue !== 'string' && borderImageSourceValue.colorStops) {
            borderImageSourceValue.colorStops.forEach(function (colorStop, colorIndex) {
                function changeBorderImageSourceGradientColor(value) {
                    var currEval = sheet.evalDeclarationValue(this.declaration.value);
                    var currGradient = stylable_gradient_1.expandGradient(currEval, 'border-image-source', 'border-image')['border-image-source'];
                    var currValue = stylable_gradient_1.normalizeGradientColorStop(currGradient.colorStops[colorIndex]);
                    var currValueMatcher = RegExp(currValue.replace('(', '\\(\\s*').replace(')', '\\s*\\)').replace(/\s/g, '\\s*'));
                    this.declaration.value = currEval.replace(currValueMatcher, preserveAlpha(sheet, value, currValue));
                    updateFromAST(this.declaration);
                }
                adder(stylable_gradient_1.normalizeGradientColorStop(colorStop), changeBorderImageSourceGradientColor);
            });
        }
    };
    ColorCollectionDriver.prototype.handleNonExpandableProperty = function (sheet, declValue, adder) {
        var updateFromAST = this.updateFromAST.bind(this);
        var shorthands = new stylable_shorthands_1.StylableShorthands(sheet.evalDeclarationValue.bind(sheet));
        var shadows = shorthands.expandShadow(declValue);
        shadows.forEach(function (shadow, index) {
            function changeNonExpandable(value) {
                var currShadows = shorthands.expandShadow(this.declaration.value);
                currShadows[index].color = preserveAlpha(sheet, value, currShadows[index].color);
                this.declaration.value = css_box_shadow_1.stringify(currShadows);
                updateFromAST(this.declaration);
            }
            shadow.color && adder(shadow.color, changeNonExpandable);
        });
    };
    ColorCollectionDriver.prototype.handleMixinProperty = function (sheet, decl, adder) {
        var _this = this;
        var meta = sheet.getMeta();
        var updateFromAST = this.updateFromAST.bind(this);
        var parseMixin = this.parseMixin.bind(this, meta);
        var mixins = parseMixin(decl);
        mixins &&
            mixins.forEach(function (mixin, index) {
                var resolvedSymbol = _this.resolveSymbol(meta.source, mixin.type);
                if (!resolvedSymbol) {
                    return;
                }
                var mixinSheet = _this.getStylesheet(resolvedSymbol.from);
                if (!mixinSheet) {
                    return;
                }
                var mixinOverrides = mixinSheet.getCSSMixinOverrides(resolvedSymbol.name);
                var mixinSheetVars = mixinSheet.getVarSymbols();
                var mixinColorOverrides = mixinOverrides.filter(function (override) { return !!mixinSheetVars[override] && mixinSheetVars[override].valueType === 'COLOR'; });
                mixinColorOverrides.forEach(function (varName) {
                    var color = sheet.evalDeclarationValue(mixinSheet.evalDeclarationValue("value(" + varName + ")", mixin.options));
                    function changeMixin(value) {
                        var currMixins = parseMixin(this.declaration);
                        currMixins[index].options[varName] = value;
                        this.declaration.value = stringifyMixins(currMixins);
                        updateFromAST(this.declaration);
                    }
                    adder(color, changeMixin);
                });
            });
    };
    ColorCollectionDriver.prototype.parseMixin = function (meta, decl) {
        return core_1.SBTypesParsers[core_1.valueMapping.mixin](decl, function (type) {
            var mixinRefSymbol = meta.mappedSymbols[type];
            return mixinRefSymbol && mixinRefSymbol._kind === 'import' && !mixinRefSymbol.import.from.match(/\.css$/)
                ? 'args'
                : 'named';
        });
    };
    return ColorCollectionDriver;
}(stylable_collection_1.CollectionDriver));
exports.ColorCollectionDriver = ColorCollectionDriver;
function addColorChangeContext(declarations, decl, value, change) {
    try {
        var color = chroma_js_1.default(value).alpha(1).css();
        if (declarations[color] === undefined) {
            declarations[color] = [];
        }
        declarations[color].push({ declaration: decl, change: change });
    }
    catch (_a) {
        //
    }
}
exports.addColorChangeContext = addColorChangeContext;
function preserveAlpha(sheet, value, currValue) {
    var newValue = "" + value;
    var currAlpha = 1;
    try {
        currAlpha = chroma_js_1.default(currValue).alpha();
    }
    catch (_a) {
        //
    }
    if (currAlpha !== 1) {
        var evalNewValue = sheet.evalDeclarationValue(newValue);
        newValue = chroma_js_1.default(evalNewValue).alpha(currAlpha).css();
    }
    return newValue;
}
exports.preserveAlpha = preserveAlpha;
function stringifyMixins(mixins) {
    return mixins
        .map(function (_a) {
        var type = _a.type, options = _a.options;
        var optionsString = Object.keys(options).length
            ? '(' +
                Object.keys(options)
                    .map(function (option) { return option + " " + options[option]; })
                    .join(', ') +
                ')'
            : '';
        return type + optionsString;
    })
        .join(', ');
}
//# sourceMappingURL=color-collection.js.map